import { useGlobalData } from "../data/GeneralData";

import RegisterCallout from "../components/RegisterCallout";
import Speakers from "../components/Speakers";
import Ticker from "../components/Ticker";
import { ApprovedCredits } from "../components/ApprovedCredits";
import CertifiedLearning from "../components/CertifiedLearning";
import { VideoRow } from "../components/VideoRow";
import SpeakerData27 from "../data/SpeakerData27";
import { PhotoScrollRow } from "../components/PhotoScrollRow";
export default function PageHome() {
  const { date, year, hotel, location } = useGlobalData();
  return (
    <>
      <div className="bg-vertical-red-purple hero-banner">
        <div
          className="cover-image"
          style={{
            "--bg-desktop": `url(/img/bg-banner-2027.webp)`,
            "--bg-mobile": `url(/img/bg-banner-mobile-2027.webp)`,
          }}
        >
          <section className="">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                {/* Left: copy */}
                <div className="col-12 col-lg-7 text-center text-lg-start">
                  <h4 className="color-white mb-2">
                    <span>
                      {date}, {year}
                    </span>
                    <span className="spacer px-1 px-lg-2 px-xl-3">•</span>
                    <span>{hotel}</span>
                    <span className="spacer px-1 px-lg-2 px-xl-3">•</span>
                    <span>{location}</span>
                  </h4>
                  <div style={{ maxWidth: "42.75em" }}>
                    <h1 className="color-white m-0">
                      Experience the country's only{" "}
                      <mark className="white-highlight">
                        compensation conference
                      </mark>{" "}
                      for all HR levels working in banks and{" "}
                      <span className="nobr">credit unions</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <section className="bg-red-purple-bottom-right">
        <div id="created-by-balancedcomp" className="container">
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-3 order-md-2 text-center text-md-end mb-5 mb-md-0">
              <img
                className="img-fluid"
                src="/img/logo-certs.webp"
                alt="HRCI and SHRM certifications"
              />
            </div>
            <div className="col-lg-8 col-md-9 order-md-1 pe-md-5 text-center text-md-start">
              <div style={{ maxWidth: "49em" }}>
                <h3 className="color-white mb-0">
                  Created by BalancedComp, FinComp brings together{" "}
                  <span className="color-yellow">industry experts</span>,{" "}
                  <span className="color-yellow">leading-edge data</span>, and{" "}
                  <span className="color-yellow">networking opportunities</span>{" "}
                  with{" "}
                  <span className="color-yellow">
                    like-minded professionals
                  </span>{" "}
                  seeking to optimize and elevate their organizations'
                  compensation strategy.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <VideoRow src="/video/video-sizzle25.mp4" />
      <Ticker />
      <section className="bg-purple pb-5">
        <div className="container p-0">
          <dov className="row">
            <div className="col text-center mb-5">
              <h1 className="color-white">Featured Speakers</h1>
            </div>
          </dov>
          <div className="row keynote-speaker-row">
            <Speakers
              filter="keynote"
              speakers={SpeakerData27}
              verticalOffset
              colWidth="6"
            />
          </div>

          <div className="row speaker-row mb-5 pb-5">
            <Speakers
              filter="non-keynote"
              speakers={SpeakerData27}
              verticalOffset
              colWidth="4"
            />
          </div>
          <div id="speakersOverlay" className="modal-content hidden"></div>
        </div>
        <PhotoScrollRow />
        <CertifiedLearning />
      </section>
      <ApprovedCredits />
      <section className="bg-rounded">
        <div className="container">
          <div className="row justify-content-center pb-5">
            <div className="col text-center">
              <h1 className="color-purple">Our Sponsors</h1>
              {/* <p>
                FinComp '27 wouldn't be possible without the support of our
                generous sponsors.
              </p> */}
            </div>
          </div>
          <div className="row justify-content-center align-items-center">
            <div className="col-12 mb-5 text-center">
              <h2 className="sponsor-label mb-3">Platinum</h2>
              <a
                href="https://newcleus.com/"
                target="_blank"
                rel="noreferrer"
                className="sponsor-card sponsor-platinum pt-4"
              >
                <div className="sponsor-logo platinum">
                  <img
                    src="../img/sponsor-logo-newcleus.webp"
                    alt="Newcleus - Financial Inovation + Insight"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <RegisterCallout className="bg-before-white" />
    </>
  );
}
